<!-- src/app/jobs/job-search-card/job-search-card.component.html -->
<div class="border border-gray-200 rounded-2xl bg-white flex flex-col p-5 shadow-xs h-full transition-all duration-150 hover:shadow-md hover:border-gray-300">

  <!-- Company Row -->
  @if (slug()) {
    <a
      [routerLink]="['/companies', slug(), 'jobs', job().id]"
      class="flex flex-col text-center items-center gap-2 mb-3.5 no-underline"
    >
      <!-- Logo -->
      <div class="h-20 bg-white flex items-center justify-center shrink-0 overflow-hidden">
        @if (logoUrl()) {
          <img
            [src]="logoUrl()"
            [alt]="(companyName() ?? '') + ' logo'"
            class="w-full h-full object-contain"
            loading="lazy"
          />
        }
      </div>

      <!-- Title + Company -->
      <div class="min-w-0">
        <div class="text-lg font-bold text-gray-900 leading-snug">
          {{ title() }}
        </div>
        @if (companyName()) {
          <div class="text-md text-gray-500 mt-0.5">
            {{ companyName() }}
          </div>
        }
      </div>
    </a>
  }

  <!-- Metadata -->
  <div class="flex flex-col gap-1.5 text-sm text-gray-500 mb-5">
    @if (location()) {
      <div>📍 {{ location() }}</div>
    }
    @if (salary()) {
      <div>💰 {{ salary() }}</div>
    }
    @if (cdl()) {
      <div>🪪 CDL {{ cdl() }}</div>
    }
    @if (driverType()) {
      <div>🚛 {{ driverType() }}</div>
    }
    @if (experience()) {
      <div>🎓 {{ experience() }}</div>
    }
    @if (freightType()) {
      <div>📦 {{ freightType() }}</div>
    }
  </div>

  <!-- CTA -->
  @if (slug()) {
    <a
      [routerLink]="['/companies', slug(), 'jobs', job().id]"
      mat-flat-button
      color="primary"
      class="mt-auto"
    >
      View Job →
    </a>
  }

</div>
